import { render, staticRenderFns } from "./ShopContract.vue?vue&type=template&id=6c5c2d5b"
import script from "./ShopContract.vue?vue&type=script&lang=js"
export * from "./ShopContract.vue?vue&type=script&lang=js"
import style0 from "./ShopContract.vue?vue&type=style&index=0&id=6c5c2d5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports